<div class="screen">
  <div class="screen-inner">
    <app-shell nav="close" action="none" title="New season" [backTo]="backTo"></app-shell>

    <form class="form" (ngSubmit)="save()">
      <label class="field">
        <span class="field-label">Season name</span>
        <input name="name" [(ngModel)]="name" placeholder="Summer 2026" />
        @if (fieldErrors['name']) { <span class="field-error">{{ fieldErrors['name'] }}</span> }
      </label>

      <label class="field">
        <span class="field-label">Start date</span>
        <input name="startDate" type="date" [(ngModel)]="startDate" />
        @if (fieldErrors['startDate']) { <span class="field-error">{{ fieldErrors['startDate'] }}</span> }
      </label>

      <label class="field">
        <span class="field-label">End date</span>
        <input name="endDate" type="date" [(ngModel)]="endDate" />
        @if (fieldErrors['endDate']) { <span class="field-error">{{ fieldErrors['endDate'] }}</span> }
      </label>

      @if (error) { <p class="error">{{ error }}</p> }

      <button class="btn-primary" type="submit" [disabled]="saving">Create season</button>
    </form>
  </div>
</div>
